module.exports = __webpack_public_path__ + "img/excursions.f5c5f85e.svg";